import { render, staticRenderFns } from "./teacherAudit.vue?vue&type=template&id=4a1091d4&scoped=true&"
import script from "./teacherAudit.vue?vue&type=script&lang=js&"
export * from "./teacherAudit.vue?vue&type=script&lang=js&"
import style0 from "./teacherAudit.vue?vue&type=style&index=0&id=4a1091d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1091d4",
  null
  
)

export default component.exports